import "./script-init";
import "@/Common/WorkingDays/WorkingDaysDialog";
//import "./Validators";
import { Authorization, Config, DataGrid, EntityDialog, Router, SettingStorage } from '@serenity-is/corelib';
//import './CustomEntityDialog';

// Caricamento dinamico delle costanti di sistema da SYS_Definitions
import { loadSystemConstants } from './Helpers/SystemConstants';
// Fire-and-forget: carica in background, i fallback sono disponibili immediatamente
loadSystemConstants().catch(err => console.warn('[ScriptInit] SystemConstants loading failed:', err));

// Spell check nativo del browser su textarea e aree contenteditable (RTE/CKEditor),
// nella lingua corrente della pagina (<html lang>). Vedi Helpers/SpellCheck.ts.
import { initSpellCheck } from './Helpers/SpellCheck';
initSpellCheck();

// ScriptInitialization.ts
Config.decimalSeparator = ',';
Config.groupSeparator = '.';
Config.dateSeparator = '/';
Config.dateFormat = 'dd/MM/yyyy';


import { UserPreferenceStorage } from '@serenity-is/extensions';
//// salva le impostazioni dell'utente nel database
DataGrid.defaultPersistanceStorage = new UserPreferenceStorage();

if (document.location.href.indexOf('Mailbox') >= 0)
    Router.mightBeRouteRegex = /.*/

// ...
//// registra le impostazioni dell'utente - vale anche in browsers condivisi
//export class UserLocalStorage implements SettingStorage {
//    getItem(key: string): string {
//        return window.localStorage.getItem(Authorization.userDefinition.Username + ":" + key);
//    }

//    setItem(key: string, value: string): void {
//        window.localStorage.setItem(Authorization.userDefinition.Username + ":" + key, value);
//    }
//}

//// ...

//// altre possibilità:
////DataGrid.defaultPersistanceStorage = window.localStorage;  // nel browser
//DataGrid.defaultPersistanceStorage = window.sessionStorage;
//DataGrid.defaultPersistanceStorage = new UserLocalStorage();
